import React, { useEffect, useState } from "react";
import classes from "./Toast.module.css";
import images from "../../assets/images";
import Toast from "./Toast";
import { useSelector } from "react-redux";

const ErrorToast = ({
  title,
  message,
  autoHideDuration,
  toastKey,
  audioFile,
  playErrorSound = false,
}) => {
  const { errorIcon } = images;
  const { PLAY_SOUND_ON_ALL_ERRORS } = useSelector(
    (state) => state.commonReducer.configData
  );
  const [open, setOpen] = useState(false);
  const [playSound, setPlaySound] = useState(playErrorSound);

  useEffect(() => {
    setOpen(true);
  }, [toastKey]);

  useEffect(() => {
    setPlaySound(playErrorSound);
  }, [playErrorSound]);

  return (
    <Toast
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      open={open}
      onClose={() => setOpen(false)}
      autoHideDuration={autoHideDuration}
      toastKey={title}
      playSound={PLAY_SOUND_ON_ALL_ERRORS || playSound}
      audioFile={audioFile}
    >
      <div className={`${classes["toast"]} ${classes["error-toast"]}`}>
        <div className={classes["toast-title-container"]}>
          <img className={classes["toast-icon"]} src={errorIcon} alt="error" />
          <div className={classes["toast-title"]}>{title}</div>
        </div>
        <div className={classes["toast-message"]}>{message}</div>
      </div>
    </Toast>
  );
};

export default ErrorToast;
